import { SettingsBluetoothSharp } from '@material-ui/icons';
import React,{useState,useEffect} from 'react';

const getScore = (submissions) => {
    var score =0;
    submissions.map((subm,index) => {
      if(subm.isSolved)
      {
          score=score+1;
      }
    })
    return score;
}

const getPenalty = (submissions) => {
  var pen=0;
    submissions.map((subm,index) => {
      if(subm.isSolved)
      {
          pen=pen+subm.penalty;
      }
    })
    return pen;
}

function UserStandingPage(props) {
    const [show, setShow] = useState(true)
    const [data, setData] = useState();
    const [dataDisplay, setDataDisplay] = useState();
    const [count,setCount]= useState(-1);
    const [score,setScore]= useState(0);
    const [loop,setLoop]= useState(false);
    useEffect(() => {
        async function fetchData()
        {
          const res=await fetch (`https://api.codedigger.tech/contest/shortCode/${props.contest}/standing`,{
            method:"GET",
            headers:{
              "Content-Type":"application/json",
            }
          });
          res
            .json()
            .then(res => setData(res))
            .then(show => setShow(false));
        }
        fetchData();
      },[])

      useEffect(() => {
          if(!show && count==-1)
          {
              data.results.standing.map((dataDisplay,index) => {
                  if(dataDisplay.user.handle == props.user  &&  count==-1)
                  {
                      setDataDisplay(dataDisplay);
                      setCount(1);
                      setScore(getScore(dataDisplay.submissions));
                  }
                  if(index == data.results.standing.length - 1)
                  {
                      setLoop(true);
                  }
              })
          }
      })

      useEffect(() => {
          if(loop && count==-1)
          {
              setCount(0);
          }
      })

    return (
        <>
               {count==1 ? 
               <>
               {dataDisplay.user.rank === "newbie" ? <h3 style={{color:'gray',marginBottom:'0'}}>{dataDisplay.user.handle}</h3>:
                            dataDisplay.user.rank === "pupil" ? <h3 style={{color:'green',marginBottom:'0'}}>{dataDisplay.user.handle}</h3>:
                            dataDisplay.user.rank === "specialist" ? <h3 style={{color:'cyan',marginBottom:'0'}}>{dataDisplay.user.handle}</h3>:
                            dataDisplay.user.rank === "expert" ? <h3 style={{color:'blue',marginBottom:'0'}}>{dataDisplay.user.handle}</h3>:
                            dataDisplay.user.rank === "candidate master"  ? <h3 style={{color:'violet',marginBottom:'0'}}>{dataDisplay.user.handle}</h3>:
                            dataDisplay.user.rank === "international master" || dataDisplay.user.rank === "master"? <h3 style={{color:'orange',marginBottom:'0'}}>{dataDisplay.user.handle}</h3>:
                            dataDisplay.user.rank === "grandmaster" || dataDisplay.user.rank === "international grandmaster" ? <h3 style={{color:'red',marginBottom:'0'}}>{dataDisplay.user.handle}</h3>:
                            <h3 style={{color:'black',marginBottom:'0'}}>{dataDisplay.user.handle}</h3>}
               <h2 style={{marginTop:'0'}}>{dataDisplay.user.name}</h2>
               <div>Problems Solved = {score}</div>
               <div>Total Penalty = {getPenalty(dataDisplay.submissions)}</div>
               <div>{dataDisplay.isOfficial ? <>Participated in Contest</>
               :<>Practiced the Problems</>
               }</div>
               <div>{dataDisplay.isVirtual ? <>Participated in Virtual Contest</>
               :<></>
               }</div>
               {dataDisplay.submissions.map((dat) => {
                   return(
                       <div>
                       <h4 style={{marginBottom:'0'}}>Problem {dat.problemIndex}</h4>
                       {dat.isSolved ? <><div>Solved</div><div>Penalty = {dat.penalty}</div></>:
                       <><div>Not Solved</div></>}
                       </div>
                   )
               })}
               
               </>:
               <>
               {count == 0 ? <h1>Not Found</h1>:<><h1>Loading</h1></>}
               </>}
        </>
    )
}

export default UserStandingPage
